import React from "react";
import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";

const processOptions = (options) =>
  options.map(({ id, attributes }) => ({
    value: id,
    label: attributes.name,
  }));

function VehicleSelect(props) {
  return (
    <RemoteSelect url="vehicles" processOptions={processOptions} {...props} />
  );
}

export default VehicleSelect;
